import React, { ReactElement } from "react"
import { SurfaceColor, Stack, Tile, useTheme } from "@carrotfertility/carotene-core"
import { useContentfulBenefitHighlights } from "./hooks/useContentfulBenefitHighlights"
import { ContentfulContentRenderer } from "#/services/contentful"

export function ContentfulBenefitHighlightsTile({ color = "blue" }: { color?: SurfaceColor }): ReactElement {
  const theme = useTheme()
  const { content, programTypeAllowsBenefitHighlight, isLoading, isError } = useContentfulBenefitHighlights()

  if (isLoading || isError || !content || !programTypeAllowsBenefitHighlight) {
    return null
  }

  return (
    <Tile id="contentful-benefit-highlights-sidebar" variant="secondary" color={color}>
      <Stack spacing={theme.spacing(theme.tokens.spacing.md)}>
        <ContentfulContentRenderer contents={content} />
      </Stack>
    </Tile>
  )
}
